import React, { useEffect, createElement } from 'react';
import { AlertBar } from './components/ui';
import { Hero } from './components/Hero';
import { SalesLetter } from './components/SalesLetter';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = (f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      }) as any;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
      (window as any).fbq('init', '1805780283420514');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-brand-cream font-inter selection:bg-brand-teal/30" data-id="element-0">
      <AlertBar data-id="element-1" />
      <main className="pt-12" data-id="element-2">
        {' '}
        {/* Padding to account for fixed AlertBar */}
        <Hero data-id="element-3" />
        <SalesLetter data-id="element-4" />
        <WhatYouGet data-id="element-5" />
        <Bonuses data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Pricing data-id="element-8" />
        <FAQ data-id="element-9" />
        <Footer data-id="element-10" />
      </main>
    </div>;
}